<template lang="html">
  <div class="coupon-getable">
    <div class="score-exchange" v-if="scoreCoupon.length > 0">
      <div class="title">
        <p>积分兑券</p>
        <p v-if="isLogin">孩子王积分:{{ userScore }}</p>
      </div>
      <div class="coupon-exchange">
        <couponItem
          v-for="sco in scoreCoupon"
          :isLogin="isLogin"
          :targetSource="targetSource"
          :needScore="true"
          :incoupon="sco"
          :changeScore="minusScore"
          :userScore="userScore"
          :key="sco.BatchCode"
        ></couponItem>
      </div>
    </div>
    <div class="go-get" v-if="freeCoupon.length > 0">
      <div class="title">
        <p>立即领券</p>
      </div>
      <div class="coupon-get">
        <ul>
          <couponItem
            v-for="co in freeCoupon"
            :isLogin="isLogin"
            :targetSource="targetSource"
            :incoupon="co"
            :key="co.BatchCode"
          ></couponItem>
        </ul>
      </div>
    </div>
    <empty
      v-show="scoreCoupon.length <= 0 && freeCoupon.length <= 0 && !fetching"
    ></empty>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import empty from '@/components/common/empty'
import couponItem from './couponSheetItem'

export default {
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      userScore: 0,
      scoreCoupon: [],
      couponUrl: `${this.$$hostname(
        'kapi'
      )}/KOPC-action/coupon4sku/getCouponList.do`,
      querytype: 2,
      fetching: true,
      // isLogin: false,
      targetSource: null // postMessage event
    }
  },
  methods: {
    async getCoupons() {
      try {
        const query = this.$$queryString.stringify({
          ...this.params,
          source: 2,
          querytype: this.querytype,
          uid: this.$$cookie('uid'),
          skey: this.$$cookie('skey')
        })
        const coupon_res = await fetch(`${this.couponUrl}?${query}`, {
          credentials: 'include'
        })
        const couponJson = await coupon_res.json()
        if (couponJson.errno === 0) {
          this.scoreCoupon = couponJson.data.changeCoupons || []
          this.freeCoupon = couponJson.data.receiveCoupons || []
          if (
            couponJson.data.userInfo.errno &&
            couponJson.data.userInfo.errno === 1024
          ) {
            // 未登录
            this.isLogin = false
          } else {
            this.isLogin = true
            this.userScore = couponJson.data.userInfo.score || 0
          }
        } else {
          this.$$toast(couponJson.errmsg)
        }
        this.fetching = false
      } catch (e) {
        console.log(e)
        this.fetching = false
      }
    },
    minusScore(score) {
      this.userScore = this.userScore - score
    }
  },
  computed: {
    ...mapState(['product']),
    freeCoupon() {
      // isShow: 1,//是否前端展示// status: 1,//1待激活, 2 生效, 3作废
      const nowTime = new Date().getTime()
      return this.product.couponList.filter(
        v =>
          v.status === 2 &&
          v.isShow === 1 &&
          v.getStartTime <= nowTime &&
          v.getEndTime >= nowTime
      )
    },
    unavailableCoupons() {
      return []
    },
    activeCoupons() {
      if (this.tab === 1) {
        return this.availableCoupons
      } else {
        return this.unavailableCoupons
      }
    },
    isLogin() {
      if (this.$$cookie('uid') && this.$$cookie('skey')) {
        return true
      }
      return false
    }
  },
  components: {
    couponItem,
    empty
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.coupon-getable {
  font-size: rem(28px);
  padding-top: rem(20px);

  .title {
    display: flex;
    padding: 0 rem(20px);
    p:first-of-type {
      flex: 1;
    }
  }
}
.coupon-get,
.coupon-exchange {
  padding: rem(20px);
}
</style>
